<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-file-invoice"></i></div>
      <div>
        Gestion des factures
        <div class="page-title-subheading">Gestion des factures</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvelle facture
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data && buttonsPermission.edit" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="selected_data && buttonsPermission.delete" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="is_active==null" (click)="setStatus(1)" type="button" class="btn btn-outline-success btn-sm btn-label waves-effect waves-light me-3">
                                Activer</button>
                               <button  *ngIf="is_active!=null &&  is_active==1" (click)="setStatus(0)" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                                Annuler</button>
                    </div>

                    <div class="form-group ms-auto">
                        <label for=""> <strong>Rechercher:</strong> </label>
                        <input placeholder="Rechercher..." class="form-control form-control-sm" type="text" name="search_text" [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Référence</th>
                                    <th>Libellé</th>
                                    <th>Date</th>
                                    <th>Montant</th>
                                    <th>Destinataire</th>
                                    <th>Type de frais</th>
                                    <th>Facture</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'periods' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.reference}}</td>
                                    <td>{{d.label}}</td>
                                    <td>{{d.date | date:"dd-MM-yyyy hh:mm:ss"}}</td>
                                    <td>{{d.amount}}</td>
                                    <td>{{d.sac?.student?.parent?.lastname}}{{d.sac?.student?.parent?.firstname}}</td>
                                    <td>{{d.type_fee?.name}}</td>
                                    <button (click)="getFile(d)" class="btn btn-sm btn-primary">Ouvrir le fichier</button>

                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                          <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer une facture</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Référence de la facture<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="reference" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="label" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Description<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="description" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Date<span class="text-danger ml-2">(*)</span></label>
                <input type="date" name="date" class="form-control" ngModel>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Type de frais <span class="text-danger ml-2">(*)</span></label>
                <ng-select ngModel name="type_fee_id">
                    <ng-option *ngFor="let p of type_fees" [value]="p.id"> {{p.name}}</ng-option>
                </ng-select>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Facture <span class="text-danger ml-2">(*)</span></label>
                <input type="file"  class="form-control" (change)="upload($event)">
            </div>
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier la facture</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Libellé<span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="label" class="form-control" [(ngModel)]="selected_data.label">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Date d'applicabilité <span class="text-danger ml-2">(*)</span></label>
                <input type="datetime-local" name="date" class="form-control" [(ngModel)]="selected_data.date">
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Type de frais <span class="text-danger ml-2">(*)</span></label>
                <ng-select [(ngModel)]="selected_data.type_fee_id" name="type_fee_id">
                    <ng-option *ngFor="let p of type_fees" [value]="p.id"> {{p.name}}</ng-option>
                </ng-select>
            </div>
        
         
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
            <table class="table table-borderless align-middle mb-0">
                <tbody>
                 
                </tbody>
            </table>
        </div>
      </div>
</ng-template>


<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>